// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jt-2";
export var container = "_jt-4";
export var dismissButton = "_jt-3";
export var hasPaddingBottom = "_jt-6";
export var last = "_jt-e";
export var scrollbarThumb = "_jt-c";
export var scrollbarTrack = "_jt-b";
export var selected = "_jt-9";
export var spin = "_jt-1";
export var spinning = "_jt-0";
export var suggestionItem = "_jt-d";
export var suggestionsPanel = "_jt-5";
export var tonePill = "_jt-8";
export var tonesContainer = "_jt-7";
export var unselected = "_jt-a";